<template>
    <div class="opModal">
        <div class="form-group">
            <label>
                <localized-text localizedKey="Invia a" text="Invia a"></localized-text>
            </label>
            <input type="text" class="form-control" v-model="email" />
        </div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Username" text="Username"></localized-text>
            </label>
            <input type="text" class="form-control" v-model="username" />
        </div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Password" text="Password"></localized-text>
            </label>
            <input type="text" class="form-control" v-model="password" />
        </div>
        <div class="text-center">
            <button class="btn btn-primary" @click="send">Invia</button>
        </div>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model'
import { mixins, Options, Vue } from 'vue-class-component';
import { BaseUserClient } from '@/services/Services';
import { ModalServices } from '@/services/ModalServices';

@Options({})
export default class accessDataModal extends Vue {

    @Prop() emailValue: string;

    email: string = "";
    username: string = "";
    password: string = "";

    created(){
        this.email = this.emailValue;
        this.username = this.emailValue;
    }

    send(){
        BaseUserClient.sendAccessData(this.email, this.username, this.password)
        .then(x => {
            this.$emit('close');
            ModalServices.alertModal('','Inviata!')
        })
    }

}
</script>
<style scoped>
</style>
